<template>
  <div class="tab-container">
    <div
      class="tab"
      :class="{ active: active === index }"
      v-for="(tab, index) in tabsArr"
      :key="index"
      @click="activeTab(index)"
      :data-test="tab"
      :id="`tab-${tab?.trim().replace(' ', '-').toLowerCase()}`"
    >
      <span>{{ tab }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      tabsArr: {
        type: Array,
      },
      initialTab: {
        type: Number,
        default: 0,
      },
      selected: Number,
    },
    data() {
      return {
        active: this.initialTab,
      };
    },
    created() {
      if (this.selected) {
        this.active = this.selected;
      }
      this.$emit('active', this.active);
    },
    methods: {
      activeTab(index) {
        this.active = index;
        this.$emit('active', this.active);
      },
    },
    watch: {
      selected(val) {
        if (val === 0 || val === 1) {
          this.active = val;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables';
  @import '@/assets/styles/mixins';

  $radius: 0.5rem;

  .tab-container {
    height: fit-content;
    width: fit-content;
    overflow: auto;
    display: flex;

    color: $neutral-gray;
    background-color: $bg-dark;
    border-radius: $radius;
    font-size: 0.875rem;

    .tab {
      padding: 0.5rem 2rem;
      flex: 1;
      min-width: fit-content;
      display: flex;
      place-content: center;
      border-radius: $radius;
      cursor: pointer;

      &.active {
        background-color: $neutral-black;
        color: $white;
      }
    }
  }
  @include mobile {
    .tab-container {
      width: 100%;
    }
  }
</style>
